import axiosInstance from './axiosInstance';
import { IFeatureFlag } from '../../types/featureFlags.types';

/**
 * Feature Flags API Service
 */

export const featureFlagsService = {
  /**
   * Get all feature flags (public endpoint)
   */
  async getFlags(): Promise<IFeatureFlag[]> {
    const response = await axiosInstance.get<IFeatureFlag[]>('/feature-flags');
    return response.data;
  },

  /**
   * Check if a specific feature flag is enabled
   */
  async isEnabled(key: string): Promise<boolean> {
    const response = await axiosInstance.get<{ key: string; enabled: boolean }>(`/feature-flags/${key}`);
    return response.data.enabled;
  },
};

